import React, {PropTypes} from 'react';
import { connect } from 'react-redux'
// SHARED
import NewClientContainer from './NewClientContainer'

class NewClientPage extends React.Component {
  render() {
    return (

        <NewClientContainer user={this.props.user} ui={this.props.ui} />

    );
  }
}

NewClientPage.propTypes = {
  user: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect()(NewClientPage)



// WEBPACK FOOTER //
// ./src/accountants/NewClientPage.js